export class PCPModel {
    pcpCards: PCPCard[];

    constructor(){
        this.pcpCards = new Array<PCPCard>();
    }
}

export class PCPCard {
    coveredMembersForPcp: CoveredMemberForPcp[];
    isLinkAvailable: boolean;
    messageLabelForDisplay: string;
    panelHeaderLabelForDisplay: string;
    pcpLinkText: string;
    pcpLinkURL: string;
    pcpPanelID: number;

    constructor(){
        this.coveredMembersForPcp = new Array<CoveredMemberForPcp>();
        this.isLinkAvailable = false;
        this.messageLabelForDisplay = null;
        this.panelHeaderLabelForDisplay = null;
        this.pcpLinkText = null;
        this.pcpLinkURL = null;
        this.pcpPanelID = 0;
    }
}

export class CoveredMemberForPcp {
    coveredMemberName: string;
    firstName: string;
    lastName: string;
    memberCoverageUniqueID: string;

    constructor(){
        this.coveredMemberName = null;
        this.firstName = null;
        this.lastName = null;
        this.memberCoverageUniqueID = null;
    }
}


export class PCPPayload {
    pcpCriterias: PCPPayloadDetail[];

    constructor(){
        this.pcpCriterias = new Array<PCPPayloadDetail>();
    }
}

export class PCPGrid {
    panelHeaderLabelForDisplay: string;
    pcpLinkText: string;
    pcpLinkURL: string;
    pcpPanelID: number;
    details: PCPPayloadDetail[];

    constructor() {
        this.panelHeaderLabelForDisplay = null;
        this.pcpLinkText = null;
        this.pcpLinkURL = null;
        this.pcpPanelID = 0;
        this.details = new Array<PCPPayloadDetail>();
    }
}

export class PCPPayloadDetail {
    memberCoverageUniqueID: string;
    physicianID: number;
    isPreExisting: boolean;
    pcpId: number;
    pcpFirstName: string;
    pcpLastName: string;
    coveredMemberName: string;

    constructor() {
        this.memberCoverageUniqueID = null;
        this.physicianID = 0;
        this.isPreExisting = false;
        this.pcpId = 0;
        this.pcpFirstName = null;
        this.pcpLastName = null;
        this.coveredMemberName = null;
    }
}
